// CENTRALIZED IMPORT FILE FOR ROUTES
/* eslint-disable */
import SaninnLogger from "@/config/debugger";
const debug = new SaninnLogger("config/routes.js", true);

import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import store from "@/config/store";

import config from "@/config/app";
const app = config.app;

import { DevModules } from "@/developers";
import Loading from "@/components/Loading";
import PageBuilderTest from "@/modules/PageBuilderTest";

// GETS MODULES ROUTES AND PUTS THEM IN ARRAY
let moduleRoutes = [];
const ViewsContext = require.context("../modules/", true, /\.(js|vue)$/i); // where 'true' means to look in all subfolders
ViewsContext.keys().map((key) => {
  const name = key.match(/\w+/)[0]; // creates comp name from file name
  const comp = ViewsContext(key).default;

  try {
    // check if route key exists push into route
    if (comp.route) {
      let route = {
        path: comp.route.path,
        name: comp.route.name || name,
        component: comp,
      };
      moduleRoutes.push(route);
      //debug.log(route)
    }
  } catch (error) {
    //console.log('err', error, name)
  }
});

let routes = [
  {
    path: "/",
    name: "App Loading",
    component: Loading,
  },
  {
    path: "/home",
    name: "Home",
    component: PageBuilderTest,
  },
];

routes = routes.concat(DevModules);
routes = routes.concat(moduleRoutes);
//routes = routes.concat(ComponentRoutes);

// add meta auth requirement to all routes except if config.app.requiresAuth is set to true
if (app.requiresAuth) {
  routes.forEach((item) => {
    // where ['/sign-in', '/register'] are routes that do not require authentication
    if (["/sign-in", "/register"].indexOf(item.path) == -1)
      item["meta"] = {
        requiresAuth: true,
      };
  });
}

debug.log("app.baseUrl", app.baseUrl);
const router = new VueRouter({
  base: app.baseUrl,
  mode: "history",
  routes,
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {

      var elements = document.querySelectorAll(".ce-header");
      elements.forEach((element) => {
        if (
          String(to.hash).substring(1) == element.getAttribute("data-anchor")
        ) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
          return {
            x: element.getBoundingClientRect().x,
            y: element.getBoundingClientRect().y,
          };
        }
      });
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  debug.log(store.getters.isAuthenticated, to, from);
  // next();
  const isAuthenticated = store.getters.isAuthenticated;
  if (to.path !== "/sign-in" && !isAuthenticated) next({ path: "/sign-in" });
  else next();
});

// BROWSER BACK BUTTON EVENT
window.popStateDetected = false;
window.addEventListener("popstate", () => {
  window.popStateDetected = true;
});
router.beforeEach((to, from, next) => {
  const IsItABackButton = window.popStateDetected;
  window.popStateDetected = false;
  // if (IsItABackButton && from.meta.someLogica) {
  if (IsItABackButton) {
    next();
    console.log("back button", IsItABackButton, window.popStateDetected);
    return "";
  }

  next();
});

export default router;
export const siteRoutes = routes;
